<p *ngIf="isLoading">Loading video...</p>

<video *ngIf="videoUrl" class="login-help-video" controls preload="metadata" [src]="videoUrl">
  Your browser does not support HTML5 video.
</video>

<p *ngIf="hasError">
  The video could not be loaded in the player.
</p>
